'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CloudDownload = require('./CloudDownload');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CloudDownload).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/CloudDownload/index.js
// module id = 1155
// module chunks = 1